

<div class="container">
  <div class="configuration-panel">
    <img-comparison-slider *ngIf="gotFacade?.imageUrl && secondryFacade?.imageUrl" value="75" class="image-slider">
      <figure slot="first" class="before">
        <div class="facade-image" [style.width]="viewerWidth" [style.height]="viewerHeight" [style.backgroundImage]="'url(' + secondryFacade?.imageUrl + ')'"></div>
      </figure>
      <figure slot="second" class="after">
        <div class="facade-image" [style.width]="viewerWidth" [style.height]="viewerHeight" [style.backgroundImage]="'url(' + gotFacade?.imageUrl + ')'"></div>
      </figure>
      
      <svg slot="handle" xmlns="http://www.w3.org/2000/svg" width="100" viewBox="-8 -3 16 6" value="75">
        <path stroke="#fff" d="M -5 -2 L -7 0 L -5 2 M 5 -2 L 7 0 L 5 2" stroke-width="2" fill="none" vector-effect="non-scaling-stroke"></path>
      </svg>
    </img-comparison-slider>

    <iframe *ngIf="!secondryFacade?.imageUrl && !connectType" [style.width]="viewerWidth" [style.height]="viewerHeight" title="Situ Facade" [src]="getLiveFacadeEmbedUrl() | safe" class="embed" frameborder="0"></iframe>
    <div *ngIf="!secondryFacade?.imageUrl && connectType" class="facade-image" [style.width]="viewerWidth" [style.height]="viewerHeight" [style.backgroundImage]="'url(' + connectUrl + ')'"></div>

    <div class="top-overlay" fxLayout="row" fxLayoutAlign="space-between center">
      <mat-icon *ngIf="linkToPortal && !displayOnly" class="link m-l-10 m-t-5" matTooltip="View in situPORTAL" aria-label="viewInPortal" 
        (click)="openInPortal(secondryLinkToPortal ? false : true)" matTooltipPosition="below" aria-hidden="false">
        exit_to_app
      </mat-icon>
      <mat-icon *ngIf="secondryLinkToPortal && !displayOnly" class="link m-r-5 m-t-5" matTooltip="View in situPORTAL" aria-label="viewInPortal" 
        (click)="openInPortal()" matTooltipPosition="below" aria-hidden="false">
        exit_to_app
      </mat-icon>
    </div>

    <div *ngIf="!displayOnly" class="homeconfig" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px">
      <a target="_blank" href="https://situsystems.com/"><img class="logo" src="https://cdn.situsystems.com/facade/2d7f08ea-ccdc-4c39-85ce-4e987ea79e65.png" alt="situSYSTEMS" matTooltip="situSYSTEMS"></a> 
    </div>
  </div>
</div>